import React from "react";
import { Sparkles } from "lucide-react";

interface GlitterIconProps {
  /** "red" glows red-orange (for light backgrounds), "gold" glows white-gold (for dark backgrounds) */
  color?: "red" | "gold";
  className?: string;
}

const GlitterIcon = ({ color = "red", className = "w-4 h-4" }: GlitterIconProps) => {
  const animationClass = color === "gold" ? "animate-glitter-gold" : "animate-glitter";
  return <Sparkles className={`${className} ${animationClass}`} />;
};

export default GlitterIcon;
